//export theme const variables
const theme = {
    colors: {
      mainBrown: '#231F20',
      mainOrange: '#FF8927',
      mainOrangeDark: '#F16E00',
      mainSilver: '#E0E0E0',
      white: '#ffffff',
      black: '#000000',
      transparent: '#ffffff00',

    },
    breakpoints: {
      small: '576px',
      medium: '768px',
      large: '992px',
      xlarge: '1200px'
    }
  }

  export default theme;